<template>
  <div style="padding-top: 16px">
    <a-form-model :label-col="{ span: 4 }" :wrapper-col="{ span: 8 }">
      <a-form-model-item :label="$t('page_theme_migration_date')">
        <a-date-picker :placeholder="$t('common_please_input') + $t('page_theme_migration_date')" style="width: 100%" :value="migrationDate" valueFormat="YYYY-MM-DD HH:mm:ss" @change="changeTime" />
      </a-form-model-item>
    </a-form-model>
    <div class="date-button">
      <a-button type="primary" @click="handleSave">保存</a-button>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import { TenantExtendServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'
import dayjs from 'dayjs'
import {  getLocalStorage } from "@/utils/storage";

const serviceProxy = new TenantExtendServiceProxy()

export default {
  data(){
    return {
      migrationDate: null,
      formValues: {},
      form: {}
    }
  },
  computed: {
    ...mapGetters(['userSettings', 'user']),
  },
  watch: {
    userSettings: {
      handler(val) {
        this.initialForm()
      },
      deep: true,
      immediate: true
    }
  },
  created(){
    this.initialForm()
  },
  methods:{
    ...mapActions('user', ['getSetting']),
    initialForm() {
      let settings = getLocalStorage('USER_SETTING')
      this.formValues = {...settings}
      this.migrationDate = settings.transferDate ? dayjs(settings.transferDate).format('YYYY-MM-DD HH:mm:ss') : null
    },
    changeTime(value){
      this.migrationDate = dayjs(value).format('YYYY-MM-DD HH:mm:ss')
    },
    handleSave(){
      const start = dayjs('2020-1-1 00:00:00').valueOf()
      const end = dayjs().valueOf()
      const date = dayjs(this.migrationDate).valueOf()
      if(start > date) {
        this.$message.warning('选择时间不能小于2020年1月1日')
        return
      }
      if(date > end) {
        this.$message.warning('选择时间不能大于当前时间')
        return
      }
      this.formValues.transferDate = dayjs(date).format('YYYY-MM-DD HH:mm:ss')
      serviceProxy.update(this.formValues).then(() =>{
        this.$message.success('编辑成功')
        this.getSetting()
      })
    }
  }
}
</script>

<style>
.date-button{
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 8px;
}
</style>
